"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconArrowLeft', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6.70711 4.70711C7.09763 4.31658 7.09763 3.68342 6.70711 3.29289C6.31658 2.90237 5.68342 2.90237 5.29289 3.29289L1.29289 7.29289C0.902369 7.68342 0.902369 8.31658 1.29289 8.70711L5.29289 12.7071C5.68342 13.0976 6.31658 13.0976 6.70711 12.7071C7.09763 12.3166 7.09763 11.6834 6.70711 11.2929L4.41421 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H4.41421L6.70711 4.70711Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M7.70711 5.70711C8.09763 5.31658 8.09763 4.68342 7.70711 4.29289C7.31658 3.90237 6.68342 3.90237 6.29289 4.29289L1.29289 9.29289C0.902369 9.68342 0.902369 10.3166 1.29289 10.7071L6.29289 15.7071C6.68342 16.0976 7.31658 16.0976 7.70711 15.7071C8.09763 15.3166 8.09763 14.6834 7.70711 14.2929L4.41421 11H18C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9H4.41421L7.70711 5.70711Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M8.70711 6.70711C9.09763 6.31658 9.09763 5.68342 8.70711 5.29289C8.31658 4.90237 7.68342 4.90237 7.29289 5.29289L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071L7.29289 18.7071C7.68342 19.0976 8.31658 19.0976 8.70711 18.7071C9.09763 18.3166 9.09763 17.6834 8.70711 17.2929L4.41421 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H4.41421L8.70711 6.70711Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M11.5607 9.06066C12.1464 8.47487 12.1464 7.52513 11.5607 6.93934C10.9749 6.35355 10.0251 6.35355 9.43934 6.93934L1.43934 14.9393C0.853553 15.5251 0.853553 16.4749 1.43934 17.0607L9.43934 25.0607C10.0251 25.6464 10.9749 25.6464 11.5607 25.0607C12.1464 24.4749 12.1464 23.5251 11.5607 22.9393L6.12132 17.5H29.5C30.3284 17.5 31 16.8284 31 16C31 15.1716 30.3284 14.5 29.5 14.5H6.12132L11.5607 9.06066Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;